import { cx } from '@platform/core/lib/cx';
import type { IPageFrameProps } from './IPageFrameProps';
import { PageCrumbs } from './PageCrumbs';
import './page.css';

/**
 * Каркас сторінки модуля (прототип v4): смуга хлібних крихт, шапка (заголовок, рядок фільтрів, розширені фільтри, панель дій) на місці
 * і тіло, що прокручується (подання, пагінація). Однаковий для таблиць, подань і сторінок модуля (огляд, поради, аналітика, довідка).
 */
export function PageFrame({ crumbs, head, children, flush }: IPageFrameProps) {
  return (
    <div className="lv-page">
      <PageCrumbs items={crumbs} />
      <div className="lv-page__head">{head}</div>
      <div className={cx('lv-page__body', flush && 'lv-page__body--flush')}>{children}</div>
    </div>
  );
}
